import {getTimezoneOffset} from '@mobi-components/global-solution';
import {SolutionResponse} from '../solution/solution-support.types';
import {APIService} from '@/services/api.service';

export async function resceduleSolution(
  sessionId: string,
  start: number,
  end: number,
  contextTimezone = '',
): Promise<SolutionResponse> {
  const localTimeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;
  const myTzOffsetMins = new Date().getTimezoneOffset();

  const timezoneOffsetMins =
    Math.round(getTimezoneOffset(new Date(), contextTimezone || localTimeZone)) - myTzOffsetMins;
  const adjustedStart = start + timezoneOffsetMins * 60;
  const adjustedEnd = end + timezoneOffsetMins * 60;

  return APIService.post<SolutionResponse>(
    `problem/new-timeframes`,
    {
      origin: {
        departure_timestamp: adjustedStart,
      },
      destination: {
        arrival_timestamp: adjustedEnd,
      },
    },
    {
      params: {
        session_id: sessionId,
      },
    },
  );
}
